import CercaMunicipi from 'components/3catinfo/CercaMunicipi';
import styles from './destacatCercadorPrevisio.module.scss';

const DestacatCercadorPrevisio = (props) => {
    const { titol, text, textCercador, marcatgeAudiencies } = props;

    return (
        <div className={styles.content}>
            <h3 className={styles.titol}>{titol}</h3>
            <p className={styles.text}>{text}</p>
            <div className={styles.cercador}>
                <CercaMunicipi
                    placeholder={textCercador}
                    inputId='search-previsio'
                    estil='contenidorFonsNegre'
                    inpuId='search-capcalera'
                    estilIcon='taronja'
                    routePath='web_3catinfo_el_temps_municipi'
                    getTitle={(item) => `Previsió del temps a ${item.nom}${item.detall || ''}`}
                    marcatgeAudienciesClick={marcatgeAudiencies ? `Tira:1:${marcatgeAudiencies?.descripcio}` : ''}
                />
            </div>
        </div>
    );
};

export default DestacatCercadorPrevisio;
